<template>
  <FilterMultiChip
    is-text
    :label="label || $t('search-filters.statuses')"
    :items="items"
    :value="value || []"
    @change="$emit('change', $event)"
  />
</template>

<script>
import FilterMultiChip from '@/components/filters/FilterMultiChip';
import { STATUS_VALUES } from '@/models/search-filters';

/**
 * Status dimension chip. Presentational: `:value` (array) in, `change` out. Builds its own
 * option list from STATUS_VALUES + i18n. Reusable across Explore / Opportunities / tenders.
 */
export default {
  name: 'StatusChip',
  components: { FilterMultiChip },
  props: {
    value: { type: Array, default: () => [] },
    // Optional label override (defaults to the shared "Status" label).
    label: { type: String, default: null },
  },
  computed: {
    items() {
      return STATUS_VALUES.map((value) => ({ value, text: this.$t(`search-filters.status.${value}`) }));
    },
  },
};
</script>
